<template>
  <button
    class="store-badge-button"
    :class="appType"
    type="button"
    @click.stop="handleTriggerClick"
  >
    <img
      class="cursor-pointer"
      :src="triggerImageSrc"
      alt=""
    />
  </button>
</template>

<script setup>
import { computed } from 'vue'
import env from '@shared/env.js'
import appStoreDe from '@shared/assets/img/app_store_de.svg'
import appStoreEn from '@shared/assets/img/app_store_en.svg'
import appStoreEs from '@shared/assets/img/app_store_es.svg'
import playStoreDe from '@shared/assets/img/play_store_de.svg'
import playStoreEn from '@shared/assets/img/play_store_en.svg'
import playStoreEs from '@shared/assets/img/play_store_es.svg'

const STORE_BADGE_CONFIG = {
  ios: {
    'en-US': {
      image: appStoreEn,
      link: env.VITE_LINK_APP_STORE_DEFAULT,
    },
    'de-DE': {
      image: appStoreDe,
      link: env.VITE_LINK_APP_STORE_DE,
    },
    'es-US': {
      image: appStoreEs,
      link: env.VITE_LINK_APP_STORE_ES,
    },
  },
  android: {
    'en-US': {
      image: playStoreEn,
      link: env.VITE_LINK_GOOGLE_PLAY_DEFAULT,
    },
    'de-DE': {
      image: playStoreDe,
      link: env.VITE_LINK_GOOGLE_PLAY_DE,
    },
    'es-US': {
      image: playStoreEs,
      link: env.VITE_LINK_GOOGLE_PLAY_ES,
    },
  },
}

const props = defineProps({
  appType: {
    type: String,
    required: true,
  },
  lang: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['click'])

const badgeConfig = computed(
  () => STORE_BADGE_CONFIG[props.appType]?.[props.lang] || null,
)

const triggerImageSrc = computed(() => badgeConfig.value?.image || '')
const triggerLink = computed(() => badgeConfig.value?.link || '')

const handleTriggerClick = () => {
  emit('click')
  window.open(triggerLink.value, '_blank')
}
</script>

<style lang="scss" scoped>
.store-badge-button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
</style>
